<template>
  <div class="brand-review-wrapper" v-if="reviewObj">
    <div class="box brand-review" :class="isNew ? 'new-brand-review' : ''">
      <img src="/static/img/icons/delete.svg" class="delete-icon" @click="deleteBrandReview(review.id)" v-if="!isNew"/>
      <b-field label="Имя">
        <b-input v-model='reviewObj.name'></b-input>
      </b-field>
      <b-field label="Компания">
        <b-input v-model='reviewObj.company'></b-input>
      </b-field>
      <b-field label="Текст">
        <b-input v-model='reviewObj.text' type="textarea"></b-input>
      </b-field>
      <b-field label="Видео">
        <b-input v-model='reviewObj.videoUrl'></b-input>
      </b-field>
      <b-switch v-model='reviewObj.isPublished'>Опубликовать отзыв</b-switch> <br>
      <div class="link-wrapper" v-if="reviewObj.fullReview || file">
        <a class="link mt-10" :href="'/' + reviewObj.fullReview" target="_blank">Просмотреть полный отзыв</a>
        <span class="delete-file" @click="deleteFile">x</span>
      </div>
      <b-field v-else class="mt-10">
        <button 
          @click="$refs.loadReviewFile.click()"
          class="button">
          Загрузить полный отзыв
        </button> <br>
        <input type="file" ref="loadReviewFile" hidden @change='loadReviewFile'/>
      </b-field>
      <button class="button is-primary mt-10 save-button" @click="save" :disabled="disabled">СОХРАНИТЬ</button>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import deepcopy from 'deepcopy'

export default {
  name: 'BrandReviewItem',
  data () {
    return {
      disabled: false,
      file: '',
      reviewObj: null
    }
  },
  props: {
    review: { }
  },
  created () {
    this.reviewObj = deepcopy(this.review || {
      name: '',
      company: '',
      videoUrl: '',
      isPublished: false,
      fullReview: ''
    })
  },
  computed: {
    isNew () {
      return this.$route.name === 'BrandReviewCreator'
    }
  },
  methods: {
    ...mapActions(['deleteBrandReview', 'updateBrandReview']),
    save () {
      if (this.reviewObj.name || this.reviewObj.company || this.reviewObj.videoUrl || this.reviewObj.text) {
        this.disabled = true
        let data = new FormData()
        data.append('data', JSON.stringify(this.reviewObj))
        data.append('file', this.file)
        this.updateBrandReview(data)
        .then(() => {
          this.disabled = false
          this.$router.push({ name: 'BrandReviews' })
          this.$toast.open({
            message: 'Сохранено'
          })
        })
      } else {
        this.$toast.open({
          message: 'Заполните хотя бы одно поле',
          type: 'is-danger'
        })
      }
    },
    deleteFile () {
      this.file = ''
      this.reviewObj.fullReview = ''
    },
    loadReviewFile (e) {
      this.file = e.target.files[0]
    }
  }
}
</script>

<style scoped>
.brand-review-wrapper {
  padding: 10px;
}
.brand-review .delete-icon {
  right: 9px;
  top: -13px;
}
.save-button {
  display: block;
  margin: 0 auto;
}
.link.mt-10 {
  display: inline-block;
}
.delete-file {
  cursor: pointer;
  color: gray;
}
.new-brand-review {
  max-width: 760px;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// BrandReviewItem.vue?ec6637c2